<div class="color-bar" [style.background-color]="fillColor" [ngStyle]="{ 'height': height }"></div>
